export const SHOW_ON_PAGES = [
  { value: 'all', label: 'all' },
  { value: 'custom', label: 'custom' },
];
